import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import OverviewList from 'pages/Billing/components/OverviewList'
import StatusPill from './StatusPill'

export default withTranslation()(function PayoutDetailCard({ t, payout, onViewAll }) {
  if (!payout) {
    return (
      <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4 flex flex-col items-center justify-center text-center gap-2 py-10">
        <p className="text-sm font-semibold text-dark-blue">{t('payout.detail.empty_title')}</p>
        <p className="text-xs text-secondary max-w-xs">{t('payout.detail.empty_hint')}</p>
      </div>
    )
  }

  const items = [
    { label: t('payout.detail.reference'), value: payout.reference },
    { label: t('payout.detail.date'), value: payout.date },
    { label: t('payout.detail.prize_type'), value: payout.prizeType },
    { label: t('payout.detail.prize_name'), value: payout.prizeName },
    { label: t('payout.detail.total_winners'), value: payout.totalWinners }
  ]

  return (
    <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4 flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-semibold text-dark-blue tracking-wide uppercase">{t('payout.detail.title')}</p>
        <StatusPill text={payout.status} tone="success" />
      </div>

      <OverviewList items={items} />

      <button
        type="button"
        onClick={onViewAll}
        className="w-full flex items-center justify-center gap-1.5 text-primary text-sm font-semibold py-2 border border-border-lines rounded-lg"
      >
        {t('payout.detail.view_all_detail')} <UIcons.UilArrowRight size={14} />
      </button>
    </div>
  )
})
